export default __webpack_public_path__ + "static/media/editProfile.a086f758.svg";